export enum FlagSize {
  SMALL = 'small',
  MID = 'mid',
}
